import React from 'react';
import Helmet from 'react-helmet';
import { withRouter, Link } from 'react-router-dom';

import { Consumer } from '../context';
import { requestRecovery, resetPassword } from '../api/v1/auth';
import Logo from '../images/logo.png';
import AppLinks from './AppLinks';

class Login extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         token: '',
         errorPass: false,
         errorMessage: '',
         successRecover: false,
         finishedProcess: false,
         render: 'usuario',
      };
      // Los enlaces con token (/recover/:id) eran de la API vieja; ahora se
      // recupera con un código de 6 dígitos que llega por correo.
      if (this.props.match.params.id) {
         this.state.render = 'invalid';
      }
   }

   async recover(e) {
      e.preventDefault();
      this.setState({ loading: true });
      const email = e.target.usuario.value || '';
      const res = await requestRecovery(email);
      if (!res.ok) {
         this.setState({ errorPass: true, errorMessage: res.message || 'No se pudo enviar el código.', loading: false });
         return;
      }
      // La respuesta es la misma aunque el correo no exista.
      this.setState({
         email,
         render: 'recover',
         errorPass: false,
         successRecover: true,
         errorMessage: 'Si el correo está registrado, recibirás un código de 6 dígitos.',
         loading: false,
      });
   }

   async changePasword(e) {
      e.preventDefault();
      const form = e.target;
      const password = form.password.value || '';
      if (password.length < 8) {
         this.setState({ errorPass: true, successRecover: false, errorMessage: 'La contraseña debe tener al menos 8 caracteres.' });
         return;
      }
      if (password !== form.confirmPassword.value) {
         this.setState({ errorPass: true, successRecover: false, errorMessage: 'Las contraseñas no coinciden.' });
         return;
      }
      this.setState({ loading: true });
      const res = await resetPassword(this.state.email, (form.code.value || '').trim(), password);
      if (!res.ok) {
         this.setState({ errorPass: true, successRecover: false, errorMessage: res.message, loading: false });
         return;
      }
      this.setState({
         errorMessage: res.message,
         successRecover: true,
         errorPass: false,
         loading: false,
         finishedProcess: true,
      });
   }

   renderusuario() {
      return (
         <React.Fragment>
            <div className="white-space-16" />
            <h3 className="text-center color-white">Recuperar contraseña</h3>
            <div className="white-space-16" />
            <form
               className="column full "
               onSubmit={(event) => {
                  this.recover(event);
               }}>
               <div className="white-space-16" />
               <div className="row full btn-container justify-center">
                  <span className="label-login color-white weight-medium">Correo:</span>
               </div>
               <div className="row full input-container ">
                  <div className="column full justify-center align-center">
                     <input
                        name="usuario"
                        type="email"
                        maxLength="200"
                        autoComplete="off"
                        placeholder="correo@ejemplo.com"
                        className="weight-semi text-center"
                        required
                     />
                  </div>
               </div>
               <div className="white-space-32" />
               <div className="row full btn-container justify-center">
                  <button type="submit" className="btn btn-primary color-white">
                     {this.state.loading ? (
                        <i className="fas fa-spinner fa-spin font-text" />
                     ) : (
                        <span className="color-white">
                           <i className="fas fa-sign-in-alt font-text" />
                           &nbsp; Recuperar
                        </span>
                     )}
                  </button>
               </div>
               {this.state.errorPass ? (
                  <React.Fragment>
                     <div className="white-space-16" />
                     <div className="column error-login">
                        <div className="white-space-8" />
                        <p className="text-center color-white">
                           {this.state.errorMessage}
                        </p>
                        <div className="white-space-8" />
                     </div>
                  </React.Fragment>
               ) : (
                  <div className="white-space-64" />
               )}
               {this.state.successRecover ? (
                  <React.Fragment>
                     <div className="white-space-16" />
                     <div className="column success-login">
                        <div className="white-space-8" />
                        <p className="text-center color-white">
                           {this.state.errorMessage}
                        </p>
                        <div className="white-space-8" />
                     </div>
                  </React.Fragment>
               ) : (
                  <div className="white-space-64" />
               )}

               <div className="white-space-64" />
            </form>
         </React.Fragment>
      );
   }

   renderRecover() {
      return (
         <React.Fragment>
            <div className="white-space-16" />
            {!this.state.finishedProcess ? (
               <h3 className="text-center color-white">Ingrese el código y su nueva contraseña</h3>
            ) : (
               <h3 className="text-center color-white">Continua en la app</h3>
            )}
            <div className="white-space-16" />
            <form
               className="column full "
               onSubmit={(event) => {
                  this.changePasword(event);
               }}>
               <div className="white-space-16" />
               {!this.state.finishedProcess ? (
                  <>
                     {[
                        ['code', 'Código', 'text', 'one-time-code'],
                        ['password', 'Nueva contraseña', 'password', 'new-password'],
                        ['confirmPassword', 'Confirmar contraseña', 'password', 'new-password'],
                     ].map(([name, label, type, auto]) => (
                        <React.Fragment key={name}>
                           <div className="row full btn-container justify-center">
                              <span className="label-login color-white weight-medium">{label}:</span>
                           </div>
                           <div className="row full input-container ">
                              <div className="column full justify-center align-center">
                                 <input
                                    name={name}
                                    type={type}
                                    maxLength={name === 'code' ? '6' : '72'}
                                    inputMode={name === 'code' ? 'numeric' : undefined}
                                    autoComplete={auto}
                                    placeholder={label}
                                    className="weight-semi text-center"
                                    required
                                 />
                              </div>
                           </div>
                           <div className="white-space-16" />
                        </React.Fragment>
                     ))}
                     <div className="white-space-32" />
                     <div className="row full btn-container justify-center">
                        <button type="submit" className="btn btn-primary color-white">
                           {this.state.loading ? (
                              <i className="fas fa-spinner fa-spin font-text" />
                           ) : (
                              <span className="color-white">
                                 <i className="fas fa-sign-in-alt font-text" />
                                 &nbsp; Cambiar Contraseña
                              </span>
                           )}
                        </button>
                     </div>
                  </>
               ) : (
                  <AppLinks />
               )}
               {this.state.errorPass ? (
                  <React.Fragment>
                     <div className="white-space-16" />
                     <div className="column error-login">
                        <div className="white-space-8" />
                        <p className="text-center color-white">
                           {this.state.errorMessage}
                        </p>
                        <div className="white-space-8" />
                     </div>
                  </React.Fragment>
               ) : (
                  <div className="white-space-64" />
               )}
               {this.state.successRecover ? (
                  <React.Fragment>
                     <div className="white-space-16" />
                     <div className="column success-login">
                        <div className="white-space-8" />
                        <p className="text-center color-white">
                           {this.state.errorMessage}
                        </p>
                        <div className="white-space-8" />
                     </div>
                  </React.Fragment>
               ) : (
                  <div className="white-space-64" />
               )}

               <div className="white-space-64" />
            </form>
         </React.Fragment>
      );
   }

   renderInvalid() {
      return (
         <React.Fragment>
            <div className="white-space-16" />
            <h3 className="text-center color-white">Este enlace ya no es válido</h3>
            <div className="white-space-16" />
            <p className="text-center color-white">
               Ahora la contraseña se recupera con un código que llega por correo.
            </p>
            <div className="white-space-16" />
            <div className="row full justify-center align-center">
               <Link to="/recover" className="color-white" onClick={() => this.setState({ render: 'usuario' })}>
                  Solicitar un código
               </Link>
            </div>
            <div className="white-space-16" />
            <form
               className="column full "
               onSubmit={(event) => {
                  this.recover(event);
               }}>
               <div className="white-space-64" />
               <div className="white-space-64" />
            </form>
         </React.Fragment>
      );
   }
   render() {
      return (
         <div className="login column align-center">
            <Helmet>
               <title>ELEVA Capital Group | Recover </title>
            </Helmet>
            <div className="justify-center content">
               <div className="full align-center justify-center">
                  <div className="column full colum-space">
                     <div className="white-space-8"></div>
                  </div>
                  <div className="column full justify-center align-center card-login">
                     <div className="responsive-img justify-center">
                        <Link to="/">
                           <img src={Logo} alt={`Logo ELEVA`} title={`Logo ELEVA`} />
                        </Link>
                     </div>
                     {this.state.render === 'usuario' ? this.renderusuario() : null}
                     {this.state.render === 'recover' ? this.renderRecover() : null}
                     {this.state.render === 'invalid' ? this.renderInvalid() : null}
                  </div>
               </div>
            </div>
         </div>
      );
   }
}
export default withRouter(Consumer(Login));
